// Shared marketing-site footer (Landing, How It Works, About).
export default function MarketingFooter() {
  return (
    <footer className="bg-foreground text-primary-foreground py-14 px-6">
      <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center mb-4">
            <img src="/IGotThat_logo_wh.svg" alt="I Got That U.S." width={271} height={40} style={{ height: '40px', width: 'auto' }} />
          </div>
          <p className="text-sm text-white/50 leading-relaxed max-w-xs">
            Peer-to-peer rentals from verified neighbors. Launching Summer 2026 in Alaska.
          </p>
        </div>
        {[
          {
            head: 'Rent',
            links: [
              { label: 'E-Bikes', href: '/browse?category=Electric+Bikes' },
              { label: 'Kayaks', href: '/browse?category=Boats+%26+Kayaks' },
              { label: 'Boats', href: '/browse?category=Boats+%26+Kayaks' },
              { label: 'Camping Gear', href: '/browse?category=Outdoor+%26+Camping+Gear' },
              { label: 'Power Tools', href: '/browse?category=Power+Tools' },
              { label: 'Baby Gear', href: '/browse?category=Baby+Equipment' },
            ],
          },
          {
            head: 'Company',
            links: [
              { label: 'About Us', href: '/about' },
              { label: 'How It Works', href: '/how-it-works' },
              { label: 'List an Item', href: '/list-item' },
              // Safety and Blog don't have dedicated pages yet -- point at
              // /browse rather than a dead "#" link until they're built.
              { label: 'Safety', href: '/browse' },
              { label: 'Blog', href: '/browse' },
            ],
          },
          {
            head: 'Support',
            links: [
              // Help Center, Contact, and Insurance don't have dedicated
              // pages yet -- point at /browse rather than a dead "#" link.
              { label: 'Help Center', href: '/browse' },
              { label: 'Contact', href: '/browse' },
              { label: 'Insurance', href: '/browse' },
              { label: 'Terms', href: '/terms' },
              { label: 'Privacy', href: '/privacy' },
              { label: 'Acceptable Use', href: '/acceptable-use' },
            ],
          },
        ].map((col) => (
          <div key={col.head}>
            <h5 className="text-xs font-semibold tracking-widest uppercase text-white/40 mb-4">
              {col.head}
            </h5>
            <ul className="flex flex-col gap-2.5">
              {col.links.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="text-sm text-white/60 hover:text-white transition-colors">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="max-w-7xl mx-auto border-t border-white/10 pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
        <p className="text-xs text-white/30">© 2026 igotthatus.com — All rights reserved</p>
        <p className="text-xs text-white/30">Made with care in Anchorage, Alaska 🏔</p>
      </div>
    </footer>
  )
}
